import React from 'react'
import { useTranslation } from 'react-i18next'

export default function SectorFirstPage({content}) {
  const { t }=useTranslation()
  return (
    <div className="w-full flex justify-center items-center py-8">
      <div className="w-full max-w-7xl  relative">
        {/* Content Section */}
        <div className="flex flex-col flex-wrap px-4 gap-y-8">
            {/* left Section */}
          <div className="w-full md:w-1/2 flex flex-col gap-4">
            <p className="flex gap-2 items-center text-gray-700">
              <svg
                width="16"
                height="2"
                viewBox="0 0 16 2"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line
                  y1="0.683105"
                  x2="16"
                  y2="0.683105"
                  stroke="#272727"
                />
              </svg>
              <span className="font-medium">{t(`${content.pageheading}`)}</span>
            </p>
          </div>

          {/* Right Section */}
          <div className="w-full md:w-1/2 md:block">
            <h1 className="text-4xl md:text-5xl mb-4 md:mb-8">
              {t(`${content.pagesubheading1}`)} <br />
              {t(`${content.pagesubheading2}`)}
            </h1>
          </div>

        </div>

        {/* Image Section */}
        <div className="p-4 md:p-8">
          <img
            src={content.image}
            className="grayscale hover:grayscale-0 h-64 sm:h-80 md:h-[35rem] w-full object-cover rounded-lg"
            alt="About us"
          />
        </div>

        {/* Background Section */}
        <div className="h-64 sm:h-80 w-64 md:w-[30rem] md:h-[30rem]  bg-blue-tint absolute bottom-0 right-0  -z-10"></div>
      </div>
    </div>
  )
}
